"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ComponentRowDual8020.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRowDual8020 = function ComponentRowDual8020(props) {
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('component8020-row-dual', props.customClass);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(bemClasses('component-container-left'))
  }, props.component1), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(bemClasses('component-container-right'))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('component-container-right-content')
  }, props.component2)));
};
var _default = exports["default"] = ComponentRowDual8020;